import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, } from '@angular/core';
import { MessageStackComponent } from "../message-stack/message-stack.component";
import { NgIf } from '@angular/common';
import { TextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { TicketService } from '../../services/ticket.service';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-ticket-details',
  imports: [MessageStackComponent, NgIf, TextBoxModule, FormsModule ],
  templateUrl: './ticket-details.component.html',
  styleUrl: './ticket-details.component.css'
})
export class TicketDetailsComponent implements OnInit {
  @Output() navigateEvent = new EventEmitter<string>();
  @Input() ticketDetails!: any;
  @Input() ccList!: string[] | null | undefined;
  addParticipantsPopup: boolean = false;
  reopenTicketPopup: boolean = false;
  tickerCreatorEA!: string;
  participants: string = ''
  participantsList: string[] = []
  openLogoutPopup: boolean = false
  userName!: string;
  reopenTicketResponse: string = ''
  participantsErrorMessage: string = '';

  reopenTicket() {
    this.reopenTicketPopup = true;
  }

  addParticipants() {
    this.participantsErrorMessage = '';
    const emailRegex = /^[a-zA-Z0-9._%+-]{1,64}@[a-zA-Z0-9.-]{1,255}\.[a-zA-Z]{2,24}$/;
    let errorMessage = '';

    if (this.participants !== '') {
      const emails = this.participants
        .split(';')
        .map(email => email.trim())
        .filter(email => email);

      const validEmails = emails.filter(email => emailRegex.test(email));
      const invalidEmails = emails.filter(email => !emailRegex.test(email));

    if (invalidEmails.length > 0) {
      errorMessage = 'Please provide valid emails separated by semicolons.';
    } else {
      this.participantsList = [
        ...this.participantsList,
        ...validEmails.filter(email => !this.participantsList.includes(email))
      ];
      this.ticketService.participantsList = this.participantsList;
    }
    }
    this.participants = '';

    if (errorMessage) {
      this.participantsErrorMessage = errorMessage;
    } else {
      this.participantsErrorMessage = '';
    }
  }

  removeParticipantFromList(participant: string) {
    this.participantsList = this.participantsList.filter(email => email !== participant);
    this.ticketService.participantsList = this.participantsList
  }

  openLogOutComponent() {
    this.openLogoutPopup = true
  }

  changeTicketStatus(ticketID: string) {
    this.ticketService.reopenTicket(ticketID).subscribe({
      next: () => {
        this.reopenTicketResponse = "Ticket is reopened."
        this.ticketDetails.ticket_status = "Reopen"
        this.reopenTicketPopup = false
      },
      error: (error) => {
        console.error(error)
        this.reopenTicketResponse = "Failed to reopen ticket. Please try again..";
      }
    })
  }

  openAddParticipantsPopup() {
    this.addParticipantsPopup = true;
  }

  navigate(path: string) {
    this.navigateEvent.emit(path)
  }

  ngOnInit(): void {
    console.log(this.ccList)
    if (this.ccList === null || this.ccList === undefined || (this.ccList.length === 1 && this.ccList[0] === '')) {
      this.ccList = []
    }
    this.participantsList = this.ccList
    console.log(this.participantsList)
    this.tickerCreatorEA = sessionStorage.getItem('emailAddress')!
    this.userName = sessionStorage.getItem('userName')!
  }

  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent): void {
    const addParticipantsDiv = this.elementRef.nativeElement.querySelector('.add-participants-container')
    const addParticipantsBtn = this.elementRef.nativeElement.querySelector('.add-participants-btn')
    const reopenTicketDiv = this.elementRef.nativeElement.querySelector('.reponen-ticket')
    const openLogoutPopup = this.elementRef.nativeElement.querySelector('.log-out-popup')


    if (addParticipantsDiv && !addParticipantsDiv.contains(event.target) && addParticipantsBtn && !addParticipantsBtn.contains(event.target)) {
      this.addParticipantsPopup = false
      this.participantsErrorMessage = ''
    }

    if (openLogoutPopup && !openLogoutPopup.contains(event.target)) {
      this.openLogoutPopup = false
    }

    if (reopenTicketDiv && !reopenTicketDiv.contains(event.target)) {
      this.reopenTicketPopup = false
    }
  }

  logout() {
    sessionStorage.clear();
    const currentDomain = window.location.hostname;
    
    if (currentDomain === 'helpdesk.teamleaseregtech.com') {
      window.location.href = 'https://login.teamleaseregtech.com/logout.aspx';
    } else if (currentDomain === 'helpdesk.avantisregtec.in') {
      window.location.href = 'https://uat.avantisregtec.in/logout.aspx';
    } else if (currentDomain === 'impl.teamleaseregtech.com') {
      window.location.href = 'https://impl.teamleaseregtech.com/logout.aspx';
    } else if (currentDomain === 'demohelpdesk.teamleaseregtech.com') {
      window.location.href = 'https://demo.teamleaseregtech.com/logout.aspx';
    } 
  }

  constructor(private readonly elementRef: ElementRef, private readonly ticketService: TicketService) {}
}
